/* istanbul ignore file */

import sat from "../../assets/img_used/gray/sat.png";
import chip from "../../assets/img_used/gray/chip.png";
import bild from "../../assets/img_used/gray/bild.png";
import welt from "../../assets/img_used/gray/welt.png";
import focus from "../../assets/img_used/gray/focus_online.svg";

export default {
  sat,
  chip,
  bild,
  welt,
  focus,
};
